module.exports = __webpack_public_path__ + "img/HuaweiY7.bdc5c969.png";